import { render } from "./HomePageUserAddress.vue?vue&type=template&id=fee19d44"
import script from "./HomePageUserAddress.vue?vue&type=script&lang=js"
export * from "./HomePageUserAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__